import api from "api";
import { computed, makeAutoObservable, runInAction } from "mobx";
import { RootStore } from "store";
import { FilterType, IMenuItem } from "types/menu";

class MenuStore {
	private _items: IMenuItem[] = [];
	rootStore: RootStore;
	activeFilter: FilterType = "All";
	page: number = 0;
	pageSize: number = 18;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
		makeAutoObservable(this);
	}

	@computed get items() {
		return (this.activeFilter !== "All" ? this._items.filter((item) => item.category === this.activeFilter) : this._items).slice(
			this.page * this.pageSize,
			(this.page + 1) * this.pageSize
		);
	}

	@computed get itemsLength() {
		return this._items.length;
	}

	setPage = (pageValueOrCallback: number | ((prevPage: number) => number)) => {
		const newPageValue = pageValueOrCallback instanceof Function ? pageValueOrCallback(this.page) : pageValueOrCallback;
		const flooredCeiledValue = Math.max(Math.min(newPageValue, this.lastPage), 0);
		return (this.page = flooredCeiledValue);
	};

	@computed get lastPage() {
		return Math.floor(this.itemsLength / this.pageSize);
	}

	setLastPage = () => {
		this.setPage(this.lastPage);
	};

	getItems = async () => {
		const res = await api.menu.get();
		return runInAction(() => (this._items = res.data));
	};

	setActiveFilter = (filterType: FilterType) => (this.activeFilter = filterType);
}

export default MenuStore;
